import { render, staticRenderFns } from "./EmployeeEditCurrent.vue?vue&type=template&id=5c2c38bf"
import script from "./EmployeeEditCurrent.vue?vue&type=script&lang=js"
export * from "./EmployeeEditCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports